<template>
  <div class="loading">
    <h1>Загрузка...<img src="../../assets/image/load.gif" alt="loading"></h1>
  </div>
</template>

<script>
export default {
  name: "show-loading",
}
</script>
